import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./App.scss";
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);

